export interface Apis {
  // 通用查询
  superSearch: string;
}

export const apis: Apis = {
  superSearch: '/saasapi/lc/api/link/query-super-data'
}
